import { render, staticRenderFns } from "./downProfit.vue?vue&type=template&id=587b4c08&scoped=true&"
import script from "./downProfit.vue?vue&type=script&lang=js&"
export * from "./downProfit.vue?vue&type=script&lang=js&"
import style0 from "./downProfit.vue?vue&type=style&index=0&id=587b4c08&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587b4c08",
  null
  
)

export default component.exports